import { useCurrentInstituteContext } from '@/context/CurrentInstituteContext'

/**
 * Returns the currently selected institute scope for the authenticated user:
 * the selected institute ID, a setter, the list of selectable institute IDs,
 * and whether the user can access the global scope.
 *
 * Reads from `CurrentInstituteContext`. Must be used inside
 * `CurrentInstituteProvider`.
 */
export function useCurrentInstitute() {
  return useCurrentInstituteContext()
}
